// Nivel de interes del prospecto. El _id es lo que se guarda en CrmProspectos.interes.
export const NIVELES_INTERES = [
  { _id: "BAJA", etiqueta: "BAJA", color: "#94a3b8" },
  { _id: "MEDIA", etiqueta: "MEDIA", color: "#3b82f6" },
  { _id: "ALTA", etiqueta: "ALTA", color: "#f59e0b" },
  { _id: "Urgente", etiqueta: "Urgente", color: "#ef4444" },
];
